
import React from 'react';

const Footer = () => (
  <div className="footer-main">
    EagleEye
  </div>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/app/components/footer/Footer.js